var DatePicker = require('modules/date-picker');
var SelectField = require('modules/select-field');

function Reserve(el) {
  var t = this,
			selectComponent;

  t.el = el;
  t.dateClose = JSON.parse( t.el.getAttribute('data-close') );
  t.dateOpen = JSON.parse( t.el.getAttribute('data-open') );
  t.dataInterval = t.el.getAttribute('data-intervals');
	t.input = document.querySelector('[data-inputpicker]');
	t.alreadyInit = false;
	t.HOUR_IN_MINS = 60;

	if( !t.dataInterval ) {
		t.dataInterval = 0.5;
	} else {
		t.dataInterval = t.dataInterval;
	}

	if( t.dateOpen ) {
		t.generateTimeList();
	}

	// Update Select Field components
	var selectEls = Array.prototype.slice.call( el.querySelectorAll('.js-reserve-field') );
	if( selectEls ) {
		selectEls.forEach( function(selectEl) {
			selectComponent = new SelectField( selectEl );
			if (selectEl.classList.contains('js-time-field')) {
				t.timeSelectComponent = selectComponent;
			}
		});
	}

	if (t.input) {
		t.updateTimePicker();
		t.input.addEventListener('change', this.updateTimePicker.bind(this));

		t.datePicker = new DatePicker(t.input, {
			 'disabled': t.dateClose ? t.dateClose : []
		});
	}
}

Reserve.prototype.updateTimePicker = function () {
	var t = this;
	var date = new Date(t.input.value);
	if ( date ) {
		t.changeTimeRange( date.getDay() );
	}
};

Reserve.prototype.generateTimeList = function() {
	var t = this;
	for( var i = 0; i < t.dateOpen.length; i++ ) {
		var time = t.dateOpen[i].time;
		if( time && time.start && time.end ) {
			var timeStart = t.convertTime( time.start ),
				timeEnd = t.convertTime( time.end ),
				intervals = parseFloat(t.dataInterval) * t.HOUR_IN_MINS;

			var timeRange = t.getTimeRange(timeStart, timeEnd, intervals);
			t.dateOpen[i].items = timeRange;
		}
	}
};

Reserve.prototype.convertTime = function(string) {
	var t = this,
			arr = string.split(':'),
			hour = parseInt(arr[0]) * t.HOUR_IN_MINS,
			minute = parseInt(arr[1]);
	return hour + minute;
};

Reserve.prototype.parseTime = function(number) {
	var hour = Math.floor(number / 60),
			offset = 'am',
			minute = number % 60;

	if (hour % 12 === 0) {
		offset = hour / 12 === 1 ? 'pm' : 'am';
		hour = 12;
	} else if (hour > 12) {
		hour = hour % 12;
		offset = "pm";
	}

	if (hour < 10) {
		hour = '0' + hour;
	}

	if (minute < 10) {
		minute = '0' + minute;
	}

	return hour + ':' + minute + offset;
};

Reserve.prototype.getTimeRange = function(start, end, interval) {
	var t = this,
			range = [];
	while( start <= end ) {
		range.push( t.parseTime(start) );
		start += interval;
	}
	return range;
};

Reserve.prototype.getMatchingTimeRange = function(dayIndex) {
	var t = this;
	for( var i = 0; i < t.dateOpen.length; i++ ) {
		if( dayIndex === t.dateOpen[i].day ) {
			return t.dateOpen[i].items;
		}
	}
};

Reserve.prototype.generateSelectFieldDropdown = function(arr) {
	var list = '';
	for( var i = 0; i < arr.length; i++ ) {
		list += '<li class="select-field__dropdown-item" data-value="' + arr[i] + '">' + arr[i] + '</li>';
	}
	return list ;
};

Reserve.prototype.generateSelectFieldNative = function(arr) {
	var options = '';
	for( var i = 0; i < arr.length; i++ ) {
		options += '<option class="select-field__option" value="' + arr[i] + '">' + arr[i] + '</option>';
	}
	return options;
};

Reserve.prototype.changeTimeRange = function(dayIndex) {
	var t = this,
		timeRange = t.getMatchingTimeRange( dayIndex),
		desktopList = t.generateSelectFieldDropdown(timeRange),
		mobileList = t.generateSelectFieldNative(timeRange),
		timeField = t.el.querySelector('.js-time-field');

	if( timeField && timeRange ) {
		// Append new time range
		timeField.querySelector('[data-field-desktop]').innerHTML = desktopList;
		timeField.querySelector('[data-field-mobile]').innerHTML = mobileList;

		t.timeSelectComponent.selectFirstItem();
	}
};

module.exports = Reserve;
